import {useMemo} from 'react';

import {
  ALL_APPS_TITLE,
  ALL_GAMES_TITLE,
  INTERESTING_TITLE,
} from '@web-catalog/const';

import {AppCategory, AppType} from '@web-catalog/types';

export const useSplitCategoriesToChunks = (
  categories: Array<AppCategory>,
  appType: AppType,
) =>
  useMemo<AppCategory[][]>(() => {
    const rowsCount = 3;
    const extraItemsCountInFirstRow = 2;
    const editArray = [...categories];
    const chunkLength = Math.round(
      (categories.length + extraItemsCountInFirstRow) / rowsCount,
    );
    const firstChunk = editArray.splice(
      0,
      chunkLength - extraItemsCountInFirstRow,
    );
    const secondChunk = editArray.splice(0, chunkLength);
    const result = [firstChunk, secondChunk, editArray];
    // дальше слегка пытаемся сбалансировать строки по длине
    const weights = result.map((arr, chunkNumber) =>
      arr.reduce(
        (lettersCount, element) => lettersCount + element.categoryName.length,
        chunkNumber === 0
          ? INTERESTING_TITLE.length +
              (appType === AppType.GAMES ? ALL_GAMES_TITLE : ALL_APPS_TITLE)
                .length
          : 0,
      ),
    );
    const {min: minWeightIndex, max: maxWeightIndex} = weights.reduce(
      (accum, weight, index) => {
        if (weights[accum.min] > weight) {
          accum.min = index;
        }
        if (weights[accum.max] < weight) {
          accum.max = index;
        }
        return accum;
      },
      {min: 0, max: 0},
    );
    const proportion =
      (weights[maxWeightIndex] / weights[minWeightIndex]) * 100;
    if (proportion > 125) {
      // если разница больше 25%, то отдаем 1 элемент с хвоста самого длинного самому короткому
      result[minWeightIndex].push(...result[maxWeightIndex].splice(-1, 1));
    }
    return result;
  }, [categories, appType]);
